import React from "react";
import { MdGroups } from "react-icons/md";
import { FaCarSide, FaShip } from "react-icons/fa";
import { MdFlightTakeoff } from "react-icons/md";
import ServicesCard from "./ServicesCard";
import { motion } from "framer-motion";

export default function ServicesSection() {
	const services = [
		{
			icon: MdGroups,
			title: "Traslado de grupos",
			description:
				"Para sus viajes de negocios, eventos deportivos, culturales y/o sociales, contamos con el servicio de traslado de grupos con el cual brindamos un servicio de atención de calidad a todos los miembros de su comité.",
		},
		{
			icon: FaCarSide,
			title: "Renta de automóviles privados y ejecutivos",
			description:
				"Ofrecemos renta de camionetas y automóviles con o sin chofer, adaptándonos a sus necesidades.",
		},
		{
			icon: MdFlightTakeoff,
			title: "Traslados aeropuerto - hotel",
			description:
				"Servicio rápido, seguro y cómodo desde el aeropuerto hacia su hotel o destino.",
		},
		{
			icon: FaShip,
			title: "Renta de embarcaciones",
			description:
				"Contamos con embarcaciones para disfrutar un día a bordo con amigos o actividades náuticas.",
		},
	];

	const containerVariants = {
		hidden: {},
		visible: {
			transition: {
				staggerChildren: 0.15,
			},
		},
	};

	return (
		<section className="w-full flex flex-col justify-center items-center py-20 px-5">
			<h2 className="text-[#cbbca3] text-5xl md:text-6xl font-bold mb-16 text-center ">
				Nuestros Servicios
			</h2>

			<motion.div
				variants={containerVariants}
				initial="hidden"
				whileInView="visible"
				viewport={{ once: true, amount: 0.2 }}
				className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 max-w-7xl w-full"
			>
				{services.map((s, i) => (
					<ServicesCard key={i} {...s} />
				))}
			</motion.div>
		</section>
	);
}
